﻿'use strict'

const section = {
    init: function () {
        var gridSections = document.getElementsByClassName("section--grid-column")
        for (var i = 0; i < gridSections.length; i++) {
            var nextSibling = gridSections[i].nextElementSibling;
            if (nextSibling && nextSibling.classList.contains('section--full-width')) {
                gridSections[i].classList.remove("section--grid-column--stroke");
            }
        }

        var fullWidth = document.getElementsByClassName("section--full-width")
        for (var i = 0; i < fullWidth.length; i++) {
            var nextSibling = fullWidth[i].nextElementSibling
            if (nextSibling.classList.contains('footer')) {
                var gridAreas = fullWidth[i].getElementsByClassName("section__area")
                if (gridAreas[0].lastElementChild != null && fullWidth[i].querySelector(".section__inner").querySelector(".banner") != null) {
                    fullWidth[i].querySelector(".section__inner").classList.remove("pb-12", "md:pb-20")
                    fullWidth[i].querySelector(".section__inner").classList.add("pb-0")
                }
            }
        }
    }
}

export default section.init()